import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const user = auth.currentUser;

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="dashboard">
      <nav className="dashboard-nav">
        <div className="nav-container">
          <div className="logo">BetaBuyers</div>
          <button onClick={handleLogout} className="btn-logout">Sign Out</button>
        </div>
      </nav>

      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1>Welcome back</h1>
          <p>{user?.email}</p>
        </div>
        
        <div className="dashboard-grid">
          <div className="dashboard-card">
            <h3>Apply to Test</h3>
            <p>Browse and apply for beta testing opportunities</p>
            <button onClick={() => navigate('/apply')} className="btn-card">
              Apply Now
            </button>
          </div>
          
          <div className="dashboard-card">
            <h3>My Applications</h3>
            <p>Track your application status and submit feedback for approved products</p>
            <button onClick={() => navigate('/my-applications')} className="btn-card">
              View Applications
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;